import React from 'react'
import { useForm } from './form'
import { useCopy } from '../clipboard/clipboard'
import { Label } from './common/label'

export const FormSimpleURL = ({ name, label, required, hidden, readonly, placeholder, defaultValue, autoFocus }) => {
  const { register, getValue } = useForm(name, { required, defaultValue, shouldDirty: true })

  const value = getValue()

  // Copied inside the click (shared/clipboard), so Safari allows it;
  // "Copied" only after a real copy, otherwise the field is selected.
  const copy = useCopy()
  const handleCopy = e => copy.copy(value, e.currentTarget.parentElement.querySelector('input'))

  const handleOpen = () => window.open(value)

  return (
    <Label name={name} label={label} required={required} hidden={hidden}>
      <div className="input-group">
        <input
          className={`form-control ${readonly && 'bg-secondary-subtle'}`}
          {...register()}
          readOnly={readonly}
          placeholder={placeholder || label || name}
          autoFocus={autoFocus}
        />

        <div className="btn-group-append" onClick={handleCopy}>
          <span className="input-group-text" style={{ cursor: 'pointer' }} role="status">
            {copy.copied ? 'Copied' : copy.manual ? copy.hint : 'Copy'}
          </span>
        </div>
        <div className="btn-group-append" onClick={handleOpen}>
          <span className="input-group-text" style={{ cursor: 'pointer' }}>
            Open
          </span>
        </div>
      </div>
    </Label>
  )
}
